import{jsx as r}from"react/jsx-runtime";function t({src:t,...e}){/*#__PURE__*/return r("img",{src:t,...e,style:{display:"none"}})}export{t as PrefetchedImage};
